module.exports = __webpack_public_path__ + "static/media/img-thumbnail-virtualgrayhounds@2x.02e7c713.png";